import React from "react";
import Layout from "./utilities/Layout";
import DropPatients from "./DropPatients";
import { withRouter } from "react-router-dom";

class PatientsList extends React.Component {
  render() {
    return (
      <Layout
        params={this.props.match.params}
        history={this.props.history}
        title="Liste des patients"
      >
        <DropPatients />
      </Layout>
    );
  }
}
export default withRouter(PatientsList);



// WEBPACK FOOTER //
// ./src/components/PatientsList.js